import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Attachment } from '../model/attachment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TokenService } from './token.service';
import { s3Presigned } from '../model/s3Presigned';

@Injectable({
  providedIn: 'root'
})
export class AttachmentsService {

  constructor(private httpClient: HttpClient, private tokenService: TokenService) { }

  generateS3UploadURL = (params: { fileName: string; contentType: string }): Promise<any> =>
    this.httpClient
      .get(`${environment.api}/s3proxy/GetPresignedUploadUrl`, {
        params,
        responseType: 'text',
        headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization' : `Bearer ${this.tokenService.getToken()}` }),
        withCredentials: true,
        observe: 'response'
      })
      .toPromise()
      .then(res => {
        let temp: s3Presigned = JSON.parse(res.body);
        const Id = temp.Id;
        const presignedURL = temp.presignedURL;        
        return { Id, presignedURL};
      });

  generateS3ImageUploadURL = (params: { fileName: string; contentType: string }): Promise<any> =>
    this.httpClient
      .get(`${environment.api}/s3proxy/GetPublicPresignedUploadUrl`, {
        params,
        responseType: 'text',
        headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization' : `Bearer ${this.tokenService.getToken()}` }),
        withCredentials: true,
        observe: 'response'
      })
      .toPromise()
      .then(res => {
        var results = JSON.parse(res.body);
        const Id = results['x-attachment-id'];
        const publicUrl = results['x-public-url'];
        const presignedURL = results['urlString'];;
        return { Id, presignedURL, publicUrl };
      });

  putFileToS3 = (body: File, presignedUrl: any, apiId: string): Promise<any> =>
    this.httpClient
      .put(presignedUrl, body, {
        headers: new HttpHeaders({
          'Content-Type': body.type
        })
      })
      .toPromise();

  putImageToS3 = (body: File, presignedUrl: string, apiId: string): Promise<any> =>
    this.httpClient
      .put(presignedUrl, body, {
        headers: new HttpHeaders({
          'Content-Type': body.type,
          //'x-amz-acl': 'public-read',
          'x-amz-meta-attachment-id': apiId
        })
      })
      .toPromise();

  generateS3DownloadURL = (params: { key: string }): Promise<any> =>
    this.httpClient
      .get(`${environment.api}/s3proxy/GetPresignedUrl`, {
        params,
        headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization' : `Bearer ${this.tokenService.getToken()}` }),
        withCredentials: true,
        responseType: 'text'
      })
      .toPromise();

  getAttachments = (params: { emailId: string }): Promise<any> => this.httpClient.get(`${environment.api}/attachment/query`, {
    params,
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization' : `Bearer ${this.tokenService.getToken()}` }),
    withCredentials: true
  }).toPromise();
  // }) => Promise.resolve(offlineData.testAttachments)

  deleteAttachment = (params: { id: string }) => this.httpClient.delete(`${environment.api}/attachment/Delete`, {
    params,
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization' : `Bearer ${this.tokenService.getToken()}`  }),
    withCredentials: true
  }).toPromise();

  updateAttachment = (body: Attachment, params: { id: string }): Promise<any> =>
    this.httpClient.put(`${environment.api}/attachment/Put`, body, {
      params,
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization' : `Bearer ${this.tokenService.getToken()}`  }),
      withCredentials: true
    }).toPromise();

  updateAttachmentArray = (body: Attachment[], params: { id: string }): Promise<any> =>
    this.httpClient.put(`${environment.api}/attachment/UpdateAll`, body, {
      params,
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization' : `Bearer ${this.tokenService.getToken()}`  }),
      withCredentials: true
    }).toPromise();

  postAttachments = (body: Attachment) => this.httpClient.post(`${environment.api}/attachment/`, body,
    {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization' : `Bearer ${this.tokenService.getToken()}`  }),
      withCredentials: true
    }).toPromise();

}
